import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import ResourceList from "./components/ResourceList";
import AddEdit from "./components/AddEdit";
import "bootstrap/dist/css/bootstrap.min.css";

class App extends Component {
  render() {
    return (
      <Router basename={window.css_js_manager.basename}>
        <div className="row">
          <div className="col-12">
            <Switch>
              <Route path="*/addedit/:id" component={AddEdit} />
              <Route path="*/" component={ResourceList} />
            </Switch>
          </div>
        </div>
      </Router>
    );
  }
}

export default App;
